<!--
  ~ Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
  -->

<div role="listbox"
     id="options-container"
     [attr.aria-multiselectable]="ariaMultiselectable"
     [attr.aria-labelledby]="listboxLabelledby"
     [attr.aria-label]="ariaLabel">
  <ng-content></ng-content>
</div>
